import { render, staticRenderFns } from "./JournalRfsView.vue?vue&type=template&id=4ffa3bf1"
import script from "./JournalRfsView.vue?vue&type=script&lang=js"
export * from "./JournalRfsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports